
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M495.167 496L451.498 44.8h0c-1.643-16.348-15.4-28.795-31.83-28.8H92.332h0c-16.43.005-30.187 12.452-31.83 28.8L16.832 496zM32.213 336h447.573M47.573 176h416.64M256.853 176v160M358.186 336l10.667 160M336.853 16l10.666 160M155.52 336l-10.667 160M176.853 16l-10.667 160","stroke-width":"31.999950000000002"}})])])
          )
        }
      }
    